import type { CourseModule } from "@/core/types";
import { lektionStichpunkte } from "./lektion-01-stichpunkte";
import { lektionEbenen } from "./lektion-02-ebenen";
import { lektionSchriftgroessen } from "./lektion-03-schriftgroessen";
import { lektionTextAbschluss } from "./lektion-04-abschluss";

export const modulText: CourseModule = {
  id: "text",
  title: "Text auf Folien",
  summary:
    "Der zweite rote Faden: Eine Folie ist kein Dokument. Stichpunkte statt Fließtext, " +
    "echte Gliederungsebenen statt Leerzeichen und Schriftgrößen, die aus dem Layout " +
    "kommen.",
  level: "Grundlagen",
  lessons: [lektionStichpunkte, lektionEbenen, lektionSchriftgroessen, lektionTextAbschluss],
};
